import type React from 'react';
import {
  Breadcrumbs,
  Panel,
  PanelBody,
  PanelHeader
} from '@itandi/itandi-bb-ui';
import Link from 'next/link';
import { VendorLayoutV2 } from '~/components/common/layouts/VendorLayoutV2';
import { VendorSettingLayout } from '~/components/common/layouts/settings/VendorSettingLayout';
import SettingStyles from '../SettingStyle.module.scss';
import { PATH } from '~/pages/vendors/settings';
import { VendorPartnerList } from '~/components/specifics/vendors/settings/vendor_partners/VendorPartnerList';

export const Page: React.FC = () => (
  <VendorLayoutV2>
    <VendorSettingLayout>
      <div className={SettingStyles.SpBreadcrumbsWrapper}>
        <Breadcrumbs
          items={[
            { label: '設定一覧', as: Link, href: PATH },
            { label: '協力会社' }
          ]}
        />
      </div>
      <Panel>
        <PanelHeader title="協力会社" />
        <PanelBody>
          <VendorPartnerList />
        </PanelBody>
      </Panel>
    </VendorSettingLayout>
  </VendorLayoutV2>
);
